import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcPrivateExitRecords from '@/types/table/wkcPrivateExitRecords';
import { PrivateExitDocumentManagementData } from '@/api/generated/privateExitDocumentManagementController';

import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcPrivateExitRecordsData extends WkcPrivateExitRecords {
 privateExitDocumentManagementList?: PrivateExitDocumentManagementData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcPrivateExitRecordsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcPrivateExitRecordsData>>(API_CONTEXT + '/app/wkcPrivateExitRecords/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcPrivateExitRecordsData>(API_CONTEXT + '/app/wkcPrivateExitRecords/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcPrivateExitRecords/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcPrivateExitRecords/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcPrivateExitRecords/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/startOnly/flowPrivateExitRecords', params, httpOptions);
  }
  static startWithBusinessKeyFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/startWithBusinessKey/flowPrivateExitRecords', params, httpOptions);
  }
  static startAndTakeUserTaskFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/startAndTakeUserTask/flowPrivateExitRecords', params, httpOptions);
  }
  static startAndSaveDraftFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/startAndSaveDraft/flowPrivateExitRecords', params, httpOptions);
  }
  static submitUserTaskFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/submitUserTask/flowPrivateExitRecords', params, httpOptions);
  }
  static viewTaskBusinessDataFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcPrivateExitRecords/viewTaskBusinessData/flowPrivateExitRecords', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcPrivateExitRecords/viewHistoricTaskBusinessData/flowPrivateExitRecords', params, httpOptions);
  }
  static listWorkOrderFlowPrivateExitRecords(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/listWorkOrder/flowPrivateExitRecords', params, httpOptions);
  }

  static publishedDataSetList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/publishedDataSet', params, httpOptions);
  }

  

  // static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
  //   return super.post<TableData<WkcPrivateExitRecordsData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  // }
    static getUserInformationByUserId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPrivateExitRecords/getUserInformation', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}


